/**
 * AdminUserAvatar
 * Flutter source: wallet_screen.dart - the `if (widget.isFromAdmin) ...[ GestureDetector(... CircleBorderAvatar ...) ]`
 * trailing-avatar blocks on the userId-targeting item types (premium package, premium
 * video, video boost, wallet operation, donation).
 *
 * Trailing round avatar shown only in the admin wallet variant. Tapping it navigates
 * to the transacting user's details. Mirrors Flutter's `CircleBorderAvatar` wrapped in
 * a `GestureDetector` → `navigateToUserDetailsScreen(userId)`. Thin wrapper over the
 * shared `WalletUserAvatar`, carrying the admin-specific qa id.
 */
import React from 'react';
import { WalletUserAvatar } from './WalletUserAvatar';

interface AdminUserAvatarProps {
  userId: string;
  alt?: string;
}

export const AdminUserAvatar: React.FC<AdminUserAvatarProps> = ({ userId, alt }) => (
  <WalletUserAvatar userId={userId} alt={alt} qaId={`admin-tx-avatar-${userId}`} />
);
